<template>
    <component :is="tag">
        <slot
            :proposal-step="step"
            :campaign="campaign"
            :proposal="proposal"
            :loaded-products="loadedProducts"
            :preselected-products="preselectedProducts"
            :load-checkout-url-products="loadCheckoutUrlProducts"
            :load-product-url="loadProductUrl"
            :remove-product="removeProduct"
            :go-next-step="goNextStep"
            :go-previous-step="goPreviousStep"
            :patch-proposal-step="patchProposalStep"
            :is-loading="isLoading"
            :is-loading-checkout-url="isLoadingCheckoutUrl"
            :is-completing-proposal="isCompletingProposal"
            :is-patching-proposal="isPatchingProposal"
            :errors="errors"
            :error-message="errorMessage"
            :check-out-url-error-message="checkOutUrlErrorMessage"
            :exit-confirmation-required="exitConfirmationRequired"
        />
    </component>
</template>

<script>
    import BaseProposalStepMixin from '../mixins/BaseProposalStepMixin';
    import { NAME_PRODUCTS } from '../../../constants/proposal-steps';
    import { isEqual, clone } from 'lodash';

    export default {
        name: 'ProductsProvider',
        mixins: [BaseProposalStepMixin],
        computed: {
            step() {
                return this.proposalSteps[NAME_PRODUCTS];
            },
            initialLoadedProducts() {
                return this.$root.v2.initialLoadedProducts;
            },
            exitConfirmationRequired() {
                return !isEqual(this.initialLoadedProducts, this.loadedProducts);
            }
        },
        methods: {
            removeProduct(index) {
                this.$root.v2.loadedProducts.splice(index, 1);
            },
            updateInitialLoadedProducts(force = false) {
                if (this.$root.v2.initialLoadedProducts === null || force) {
                    this.$root.v2.initialLoadedProducts = clone(this.loadedProducts);
                }
            },
            updateInitialStepState() {
                this.updateInitialLoadedProducts(true);
            }
        },
        created() {
            this.isLoading = true;

            this.loadContact()
                .then(() => {
                    return Promise.all([this.loadCampaign(), this.loadProposal()]);
                })
                .then(() => {
                    return this.loadPreselectedProducts();
                })
                .then(() => {
                    this.initProposalStep(this.step);
                })
                .catch((error) => this.handleHttpError(error))
                .then(() => {
                    this.updateInitialLoadedProducts();
                    this.isLoading = false;
                });
        }
    };
</script>
